import React, { Component } from 'react';
import { Card } from 'reactstrap';
import Header from './../common/Header';
import Loader from './../common/Loader';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { fetchUserList } from '../../actions/UserDetails/UserAction';
import { connect } from 'react-redux';

function getCaret(direction) {
    if (direction === 'asc') {
        return (
            <i className="fa fa-sort-amount-asc" aria-hidden="true" style={{ color: '#808080', paddingLeft: 10 }} />
        );
    }
    if (direction === 'desc') {
        return (
            <i className="fa fa-sort-amount-desc" aria-hidden="true" style={{ color: '#808080', paddingLeft: 10 }} />
        );
    }
    return (
        <i className="fa fa-arrows-v" aria-hidden="true" style={{ color: '#808080', paddingLeft: 10 }} />
    );
}

class UserDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true
        };
        this.options = {
            defaultSortName: 'name',
            defaultSortOrder: 'desc' 
        };
    }

    componentWillMount() {
        const { users } = this.props;
        this.props.fetchUserList(users);
    }

    componentDidMount() {
        setTimeout(() => this.setState({ loading: false }), 500);
    }

    csvFormatter(cell, row) {
        return `${row.id}: ${cell} USD`;
    }

    render() {
        const { loading } = this.state;
        const { userList } = this.props;
        const options = {
            page: 1,
            sizePerPageList: [{ text: '10', value: 10 }, { text: '20', value: 20 }, { text: 'All', value: userList.length }], // you can change the dropdown list for size per page
            sizePerPage: 10,
            pageStartIndex: 1,
            paginationSize: 3,
            prePage: 'Prev',
            nextPage: 'Next',
            firstPage: 'First',
            lastPage: 'Last',
            paginationPosition: 'bottom'
        };
        return (
            <div style={{ overflowX: 'hidden', overflowY: 'hidden' }}>
                <Header />
                {
                    loading === true ? <Loader /> :
                        <div style={{ padding: 25 }}>
                            <Card style={{ borderColor: '#7ed321', padding: 25, boxShadow: `0px 1px 15px 5px rgba(0,0,0,0.05)` }}>
                                <BootstrapTable exportCSV data={userList} options={options} pagination search hover multiColumnSearch>
                                    <TableHeaderColumn dataField='user_id' isKey dataSort width="110" dataAlign='center' caretRender={getCaret}>User ID</TableHeaderColumn>
                                    <TableHeaderColumn dataField='name' dataSort width="145" dataAlign='center' caretRender={getCaret}>Name</TableHeaderColumn>
                                    <TableHeaderColumn dataField='phone' dataSort width="145" dataAlign='center' caretRender={getCaret}>Phone</TableHeaderColumn>
                                    <TableHeaderColumn dataField='email' dataSort width="270" dataAlign='center' caretRender={getCaret}>Email</TableHeaderColumn>
                                    <TableHeaderColumn dataField='email_verified' width="130" dataAlign='center'>Email Verified</TableHeaderColumn>
                                    <TableHeaderColumn dataField='super_user' width="110" dataAlign='center'>Super User</TableHeaderColumn>
                                    <TableHeaderColumn dataField='favourite_bin' width="160" dataAlign='center' caretRender={getCaret}>Favourite Bin</TableHeaderColumn>
                                    <TableHeaderColumn dataField='signup_on' dataSort dataAlign='center' caretRender={getCaret}>Signedup On</TableHeaderColumn>
                                </BootstrapTable>
                            </Card>
                        </div>
                }
                <br /><br />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        users: state.login.user,
        userList: state.userList.userData
    };
}

export default connect(mapStateToProps, { fetchUserList })(UserDetails);



// WEBPACK FOOTER //
// ./src/components/UserDetails/UserDetails.js